import { Component, OnInit } from '@angular/core';

import { Location } from '@angular/common';

import { NotificationService } from 'src/app/Service/notification.service';

import { FormGroup, FormBuilder, FormControl, NgForm, Validators } from '@angular/forms';

import axios from 'src/app/Service/axios';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { OtherService } from 'src/app/Service/other.service';

import { ActivatedRoute, Router } from '@angular/router';

import momentJalaali from 'moment-jalaali';

import * as moment from 'moment-jalaali'

declare let $: any;

@Component({

  selector: 'app-temp-access-admin',

  templateUrl: './temp-access-admin.component.html',

  styleUrls: ['./temp-access-admin.component.css']

})

export class TempAccessAdminComponent implements OnInit {

  list_Result: any = [];

  list_Search: any = [];

  bEditMode: boolean = false;

  mdlTempAccess: FormGroup = this.FormBuilder.group({

    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

    strUnitID: new FormControl(''),

    iTemporaryAccess: new FormControl(''),

    strSDate: new FormControl('', Validators.required),

    strSTime: new FormControl('', Validators.required),

    strEDate: new FormControl('', Validators.required),

    strETime: new FormControl('', Validators.required),

    strMobile: new FormControl('', Validators.required),

    strPassword: new FormControl('', Validators.required),

  })

  constructor(

    private location: Location,

    private tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private gurdService: GurdServiceService,

    private otherService: OtherService,

    private router: Router,

    private route: ActivatedRoute

  ) { }

  ngOnInit(): void {

    //timePicker
    $('.clockpicker').clockpicker({

      donetext: 'top',

      align: 'top',

      autoclose: true,

    });

    this.route.queryParams.subscribe((params) => {

      if (!params['id']) {

        this.router.navigateByUrl("/login");

      }

      else {

        this.mdlTempAccess.controls['strUnitID'].setValue(params['id'])

        this.getTempAccess()

      }

    })

  }

  getTempAccess = async () => {

    // var model = {

    //   strUnitID: `359632107832435`,

    // };

    this.otherService.Showspinner();

    const resp = await axios.post(`TemporaryAccess_List`, this.otherService.stringNumberToNumber(this.mdlTempAccess.value));

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    this.list_Result = res;

    this.list_Search = res;

  }

  filter_list(val: any) {

    this.list_Result = this.list_Search.filter((el: any) => {

      return el.strFullName.includes(val.value) ||

        el.strMobile.includes(val.value) ||

        el.strSDate.includes(val.value) ||

        el.strEDate.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.list_Result = this.list_Search;

    }

  }

  openModal(bEdit: boolean, item?: any) {

    this.mdlTempAccess.patchValue({

      strSDate: momentJalaali().format('jYYYY/jMM/jDD'),

      strSTime: momentJalaali().format('HH:mm'),

      strEDate: momentJalaali().format('jYYYY/jMM/jDD'),

      strETime: '23:59',

      strMobile: '',

      strPassword: '',

    })

    this.bEditMode = bEdit;

    if (this.bEditMode) {

      Object.keys(item).forEach((key: any) => {

        this.mdlTempAccess.get(key)?.setValue(item[key])

      })

    }

    $("#tempAccess-modal").modal("show");


  }

  new_TempAccess = async () => {

    const Stime = document.getElementById("Stime") as any;

    const Etime = document.getElementById("Etime") as any;

    const strSTime = moment(Stime.value.trim(), 'HH:mm').format('HH:mm');

    this.mdlTempAccess.get('strSTime')?.setValue(Stime.value);

    this.mdlTempAccess.get('strETime')?.setValue(Etime.value);

    if (this.mdlTempAccess.invalid) return this.tooltip.showError('لطفا فرم را با دقت تکمیل کنید');

    if (moment(this.mdlTempAccess.get('strSDate')?.value.trim(), 'jYYYY/jMM/jDD').isBefore(moment(), 'day')) {

      return this.tooltip.showError('تاریخ شروع نمی تواند قبل از امروز باشد');

    }

    if (moment(this.mdlTempAccess.get('strEDate')?.value.trim(), 'jYYYY/jMM/jDD').isBefore(moment(), 'day')) {

      return this.tooltip.showError('تاریخ پایان نمی تواند قبل از امروز باشد');

    }

    if (moment(this.mdlTempAccess.get('strEDate')?.value.trim(), 'jYYYY/jMM/jDD').isBefore(moment(this.mdlTempAccess.get('strSDate')?.value.trim(), 'jYYYY/jMM/jDD'))) {

      return this.tooltip.showError('تاریخ پایان نمی تواند قبل از تاریخ شروع باشد');

    }

    if (moment(strSTime, 'HH:mm').isBefore(moment(moment().format('HH:mm'), 'HH:mm'))) {

      return this.tooltip.showError(`ساعت شروع نمی تواند گذشته باشد. (زمان فعلی : ${moment().format('HH:mm')})`);

    }

    if (this.mdlTempAccess.get('strMobile')?.value.length < 10) return this.tooltip.showError('لطفا شماره موبایل را به درستی وارد کنید');

    if (!this.bEditMode) {

      this.otherService.Showspinner();

      const resp = await axios.post(`TemporaryAccess_Save`, this.otherService.stringNumberToNumber(this.mdlTempAccess.value));

      this.otherService.nonespinner();

      let res = JSON.parse(resp.data);

      if (res.iResult == 0) return this.tooltip.showError(res.strError);

      this.tooltip.showSuccess('با موفقیت ثبت شد');

      this.list_Result.push(res[0]);

      $("#tempAccess-modal").modal("hide");

    }

    else {

      $.confirm({

        title: `آیا از ویرایش دسترسی اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              this.otherService.Showspinner()

              let res = JSON.parse((await axios.post(`TemporaryAccess_Edit`, this.otherService.stringNumberToNumber(this.mdlTempAccess.value))).data.toString());

              this.otherService.nonespinner();

              if (res.iResult == 0) return this.tooltip.showError(res.strError);

              this.tooltip.showSuccess('با موفقیت ویرایش شد');

              const tempAccess = this.list_Result.filter((el: any) => {

                return el.iTemporaryAccess == this.mdlTempAccess.get('iTemporaryAccess')?.value;

              });

              const index = this.list_Result.indexOf(tempAccess[0]);

              if (index != -1) this.list_Result[index] = res[0];

              $("#tempAccess-modal").modal("hide");

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

  }

  remove_TempAccess = async (item: any, index: number) => {

    $.confirm({

      title: `آیا از حذف این دسترسی اطمینان دارید؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            var model = {

              iTemporaryAccess: item.iTemporaryAccess,

              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

            }

            this.otherService.Showspinner();

            const resp = await axios.post(`TemporaryAccess_Delete`, this.otherService.stringNumberToNumber(model));

            this.otherService.nonespinner();

            let res = JSON.parse(resp.data);

            if (res.iResult == 0) return this.tooltip.showError(res.strError);

            this.list_Result.splice(index, 1);

            return this.tooltip.showSuccess('دسترسی با موفقیت حذف شد');

          }

        },

        cancel: {

          text: "لغو",


        }

      }

    });

  }

  openSmsModal(item: any) {

    Object.keys(item).forEach((key: any) => {

      this.mdlTempAccess.get(key)?.setValue(item[key])

    })

    $("#tempSMS-modal").modal("show");


  }

  send_SMS = async () => {

    const strMobile = this.mdlTempAccess.get('strMobile')?.value;

    if (this.mdlTempAccess.invalid) return this.tooltip.showError('لطفا فرم را با دقت تکمیل کنید');

    if (strMobile.length < 11 || strMobile.length > 11) return this.tooltip.showError('لطفا شماره موبایل را به درستی وارد کنید');

    this.otherService.Showspinner();

    const resp = await axios.post(`TemporaryAccess_SMSURL`, this.otherService.stringNumberToNumber(this.mdlTempAccess.value));

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.iResult == 0) return this.tooltip.showError(res.strError);

    this.tooltip.showSuccess('پیامک با موفقیت ارسال شد');

    $("#tempSMS-modal").modal("hide");


  }

}
